import { createRoute, redirect } from "@tanstack/react-router";
import { CreateFirstTeamForm } from "@/components/CreateFirstTeamForm";
import { flushPendingSignUp } from "@/lib/analytics";
import { authClient } from "@/lib/auth";
import { loginRoute } from "./loginRoute";
import { rootRoute } from "./rootRoute";

export const createTeamRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/create-team",
    beforeLoad: async () => {
        const session = await authClient.getSession();
        const hasActiveUser = !!session.data?.user;

        if (!hasActiveUser) {
            throw redirect({
                to: loginRoute.to,
                search: {
                    redirect: window.location.href,
                },
            });
        }

        flushPendingSignUp(session.data?.user);
    },

    component: () => {
        return (
            <div className="bg-muted flex min-h-svh min-w-svw flex-col items-center justify-center gap-6 p-6 md:p-10">
                <div className="flex w-full max-w-sm flex-col gap-6">
                    <CreateFirstTeamForm />
                </div>
            </div>
        );
    },
});
